import {
  SWITCH,
  SWITCH_VALUE,
  SWITCH_AND_VALUE
} from './types'

export default {

  [SWITCH]({commit}, payload) {
    if (window.sessionStorage) {
      for (let featureName in payload) {
        const featureValue = payload[featureName]

        if (featureValue) {
          window.sessionStorage.setItem(featureName, featureValue)
        } else {
          window.sessionStorage.removeItem(featureName)
        }
      }
    }
    commit(SWITCH, payload)
  },
  [SWITCH_VALUE]({commit}, payload) {
    if (window.sessionStorage) {
      for (let featureName in payload) {
        const featureValue = payload[featureName]

        if (featureValue) {
          window.sessionStorage.setItem(featureName + '-value', featureValue)
        } else {
          window.sessionStorage.removeItem(featureName + '-value')
        }
      }
    }
    commit(SWITCH_VALUE, payload)
  },
  [SWITCH_AND_VALUE]({commit}, payload) {
    if (window.sessionStorage) {
      for (let featureName in payload) {
        const isEnabled = payload[featureName].enabled
        const value = payload[featureName].value

        if (isEnabled) {
          window.sessionStorage.setItem(featureName, isEnabled)
          window.sessionStorage.setItem(featureName + '-value', value)
        } else {
          window.sessionStorage.removeItem(featureName)
          window.sessionStorage.removeItem(featureName + '-value')
        }
        commit(SWITCH, {[featureName]: isEnabled})
        commit(SWITCH_VALUE, {[featureName]: value})
      }
    }
  }
}
